import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { ErrorMessage } from 'types';
import { client } from 'utils/api-client';

export default function useDeletePayRate(): UseMutationResult<
  AxiosResponse<null>,
  AxiosError<ErrorMessage>,
  string
> {
  const queryClient = useQueryClient();

  const deletePayRate = (payRateId: string): Promise<AxiosResponse<null>> => {
    return client.delete(`pay-rates/${payRateId}/`);
  };

  return useMutation(deletePayRate, {
    onSuccess: () => {
      queryClient.removeQueries('payRates');
    },
  });
}
